import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphCtaGroupItem = ({ entity }) => {
  const classes = classNames('CtaGroupItem');
  let url = false;
  if (entity.getIn(['field_link'])) {
    url = entity.getIn(['field_link', 0, 'alias']) ? entity.getIn(['field_link', 0, 'alias']) : entity.getIn(['field_link', 0, 'uri']);
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      {url ? (
        <CoreLink to={url} className="overlapping-link" />
      ) : null}
      <div className="CtaGroupItem__content">
        {entity.getIn(['field_image', 0]) ? (
          <div className="CtaGroupItem__imageWrapper">
            <Image
              alt={entity.getIn(['field_image', 0, 'title'], '')}
              lazyload={false}
              src={entity.getIn(['field_image', 0, 'styles', 'teaser_square'], '')}
              className="CtaGroupItem__image"
            />
          </div>
        ) : null}
        <div className="CtaGroupItem__contentWrapper">
          {entity.getIn(['field_title', 0, 'value']) ? (
            <h2 className="title">{entity.getIn(['field_title', 0, 'value'])}</h2>
          ) : null}
          {entity.getIn(['field_cta_text', 0, 'value']) ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body"
              html={entity.getIn(['field_cta_text', 0, 'value'], '')}
            />
          ) : null}
        </div>
      </div>
      <div className="link-icon">
        <i className="icon-before icon-caret icon-variant-3" />
      </div>
    </article>
  );
};

export default ParagraphCtaGroupItem;
